export const appSumoPrefix = 'OTAS_';
export const techSoupPrefix = 'OTTS_';

// coupons that are only valid for users who have not subscribed before
export const restrictedNewUserCoupons = ['BIZ20OFF3MTH_OT26'];
